import React from "react";
import useIcons from "../../../hooks/use-source-icons";
import { Variants, motion } from "framer-motion";
import Title from "@components/common/Title";
export interface TileProps {
  title: string;
  subTitle: string;
  icon: string;
  tileClassName?: string;
  key: string | number;
  color: string;
}
const tileVariant: Variants = {
  offscreen: {
    y: 200,
    opacity: 0,
  },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      bounce: 0.4,
      duration: 0.5,
    },
  },
};

const Tile: React.FC<TileProps> = ({
  title,
  subTitle,
  icon,
  tileClassName,
  color,
}) => {
  const { getFromReactIcons } = useIcons();
  const Icon = getFromReactIcons(icon);
  const additionalStyle = color ? { backgroundColor: color } : {};
  return (
    <motion.div
      className={tileClassName}
      style={{
        boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.06)",
        ...additionalStyle,
      }}
      variants={tileVariant}
    >
      {Icon && (
        <div className="mb-3">
          <Icon size={30} className="hidden xl:block" />
          <Icon size={20} className="xl:hidden" />
        </div>
      )}
      <Title titleText={title} variant="h3" />
      <Title titleText={subTitle} variant="paragraph" />
    </motion.div>
  );
};
export default Tile;
